import { formatAktivArchiviertPair } from "@shared/serviceFalltypCounts.js";
import {
  GARANTIE_FALLTYP_EMOJI,
  SERVICE_AUFTRAG_EMOJI,
  SERVICE_AUFTRAG_LABEL,
  emojiForProjektTyp,
  labelForProjektTyp,
  projektTypFromCountKey,
} from "../constants/projektTypVisuals.js";

export const KULANZ_FALLTYP_EMOJI = "🤝";

/**
 * Baut die Chip-Liste für die Objekt-Übersicht:
 * aktive Typ-Zähler, Archiv je Typ, plus Garantie/Kulanz.
 */
export function buildObjektCountsStripItems(objekt) {
  const counts = objekt?.counts || {};
  const archived = objekt?.archivedCounts || {};
  const falltyp = objekt?.serviceFalltypCounts || {};
  const items = [];

  const keys = new Set([...Object.keys(counts), ...Object.keys(archived)]);
  for (const key of keys) {
    if (key === "wartungsvertraege") continue;
    const aktiv = Number(counts[key] || 0);
    const archiv = Number(archived[key] || 0);
    if (aktiv <= 0 && archiv <= 0) continue;

    if (key === "serviceauftraege") {
      items.push({
        id: "serviceauftraege",
        emoji: SERVICE_AUFTRAG_EMOJI,
        label: SERVICE_AUFTRAG_LABEL,
        count: aktiv,
        sublabel: formatAktivArchiviertPair(aktiv, archiv),
        title: `Service: ${formatAktivArchiviertPair(aktiv, archiv)}`,
      });
      continue;
    }

    const typ = projektTypFromCountKey(key);
    items.push({
      id: key,
      emoji: emojiForProjektTyp(typ),
      label: labelForProjektTyp(typ),
      count: aktiv,
      sublabel: archiv > 0 ? formatAktivArchiviertPair(aktiv, archiv) : null,
      title: archiv > 0
        ? `${labelForProjektTyp(typ)}: ${formatAktivArchiviertPair(aktiv, archiv)}`
        : `${labelForProjektTyp(typ)}: ${aktiv}`,
    });
  }

  const g = falltyp.GARANTIE || { aktiv: 0, archiv: 0 };
  const k = falltyp.KULANZ || { aktiv: 0, archiv: 0 };
  if (g.aktiv + g.archiv > 0) {
    items.push({
      id: "falltyp-garantie",
      emoji: GARANTIE_FALLTYP_EMOJI,
      label: "Garantie",
      count: g.aktiv + g.archiv,
      sublabel: formatAktivArchiviertPair(g.aktiv, g.archiv),
      title: `Garantie: ${formatAktivArchiviertPair(g.aktiv, g.archiv)}`,
    });
  }
  if (k.aktiv + k.archiv > 0) {
    items.push({
      id: "falltyp-kulanz",
      emoji: KULANZ_FALLTYP_EMOJI,
      label: "Kulanz",
      count: k.aktiv + k.archiv,
      sublabel: formatAktivArchiviertPair(k.aktiv, k.archiv),
      title: `Kulanz: ${formatAktivArchiviertPair(k.aktiv, k.archiv)}`,
    });
  }

  return items;
}
